import { render } from "./title_value.vue?vue&type=template&id=31981bed"
import script from "./title_value.vue?vue&type=script&lang=js"
export * from "./title_value.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/project/wp-content/themes/resource-database/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__